import { DirectiveBinding } from 'vue';

export const interact = {
  mounted(el: HTMLElement) {
    el.style.transition = 'box-shadow 50ms ease';
    el.style.cursor = 'pointer';
    el.addEventListener('mouseenter', () => {
      el.style.boxShadow = 'inset 0px 0px 200px 100px rgba(225, 225, 225, 0.04)';
      el.style.cursor = 'pointer';
    });
    el.addEventListener('mouseleave', () => {
      el.style.boxShadow = 'none';
    });
  }
}; 